import { GridPanelName } from './types';

export const panelMap: { [key: string]: GridPanelName } = {
  file: 'contentLibrary',
  whiteboard: 'whiteboard',
  screenshare: 'screenshare',
};
